import { useCallback } from 'react'

import SubscriptionEvents from 'Pods/Shared/Constants/subscriptionEvents'
import useTracker from 'Pods/Shared/Hooks/useTracker'

const PAGE_TYPE = 'item_page'

const CTA_CLICK_FLUSH_TIMEOUT_MS = 1000

const useItemPageSubscriptionTracking = ({ itemId }) => {
  const { trackEvent } = useTracker()

  const trackCtaClick = useCallback((onComplete) => {
    trackEvent(
      SubscriptionEvents.ITEM_CTA_CLICK,
      { page_type: PAGE_TYPE, item_id: itemId },
      typeof onComplete === 'function'
        ? { eventCallback: onComplete, eventTimeout: CTA_CLICK_FLUSH_TIMEOUT_MS }
        : {}
    )
  }, [trackEvent, itemId])

  return {
    trackCtaClick,
  }
}

export default useItemPageSubscriptionTracking
